import React from 'react';
import { Form, Tooltip } from 'antd';
import EventsSelect from '@src/emp-3.0/components/EventsSelect';
import CustomFormItem from '@src/emp-3.0/components/Metrics/IndividualMetric/MetricBuilder/CustomFormItem';
import EventItem from '@src/emp-3.0/components/Metrics/Flow/FlowForm/EventItem';
import { EEventType } from '@src/emp-3.0/types';
import { useMetricBuilderStore } from '@src/emp-3.0/components/Metrics/IndividualMetric/store';
import { InfoCircleOutlined } from '@ant-design/icons';
interface IWithoutEventProps {
  form: any;
  isView: boolean;
}

const WithoutEventMetric: React.FC<IWithoutEventProps> = ({ form, isView }) => {
  const { withoutEvent, setWithoutEvent } = useMetricBuilderStore();

  const withoutEventId = Form.useWatch(['definition', 'without_event'], form);

  const onEventChange = (_, type, event) => {
    const eventType = typeof event === 'string' ? 'raw' : 'mapped';
    const eventValue = eventType === 'mapped' ? event.event_id : event;

    // Clear the event from store when selecting a new event
    setWithoutEvent(null);

    form.setFieldsValue({
      definition: {
        without_event: eventValue,
      },
    });
  };

  return (
    <div id="without_event" style={{ display: withoutEventId || !isView ? 'block' : 'none' }}>
      <div style={{ gap: '96px', display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.85)' }}>Exclusion Event</span>
          <span style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.45)', marginLeft: '4px' }}>
            (Optional)
          </span>
          <Tooltip
            title={
              'Represents an event that removes or disqualifies the current record from the metric calculation, and future initial event start a new record.'
            }
            placement="rightBottom"
          >
            <InfoCircleOutlined style={{ opacity: '0.4', fontSize: '18px', marginLeft: '8px' }} />
          </Tooltip>
        </div>

        <CustomFormItem
          name={['definition', 'without_event']}
          dependencies={[
            ['definition', 'first_event'],
            ['definition', 'second_event'],
          ]}
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                const firstEvent = getFieldValue(['definition', 'first_event']);
                const secondEvent = getFieldValue(['definition', 'second_event']);
                if (!value || !(firstEvent === value || secondEvent === value)) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error('Without Event cannot be the same as Initial Event or Complete Event'),
                );
              },
            }),
          ]}
          style={{
            display: isView ? 'none' : 'block',
            marginBottom: '12px',
            flex: 1,
            alignItems: 'center',
          }}
        >
          <EventsSelect
            eventType={EEventType.WITHOUT_EVENT}
            onChange={(value, event) => {
              onEventChange(value, 'without_event', event);
            }}
          />
        </CustomFormItem>
      </div>
      <EventItem
        type={EEventType.WITHOUT_EVENT}
        eventId={withoutEventId}
        event={withoutEvent}
        viewModeProps={{
          onEdit: (event) => {
            setWithoutEvent(event);
          },
          onDelete: () => {
            setWithoutEvent(null);
            form.setFieldValue(['definition', 'without_event'], null);
          },
          onClone: (event) => {
            setWithoutEvent(event);
          },
        }}
        editModeProps={{
          onSave: (event) => {
            form.setFieldsValue({
              definition: { without_event: event.event_id },
            });
            setTimeout(() => {
              setWithoutEvent(null);
            }, 100);
          },
          onCancel: () => {
            setWithoutEvent(null);
          },
          onChange: (event) => {
            if (Number(event)) {
              form.setFieldsValue({
                definition: { without_event: event },
              });
              form.validateFields([
                ['definition', 'first_event'],
                ['definition', 'second_event'],
              ]);
              setTimeout(() => {
                setWithoutEvent(null);
              }, 100);
            } else {
              setWithoutEvent(event);
            }
          },
        }}
      />
    </div>
  );
};

export default WithoutEventMetric;
